import banks from './banks.json'

export const getBank = (code) => {
  return banks.filter(bank => bank.code === code)[0]
}

export const getBanks = () => {
  return banks
}